<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--workwear wash light">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Workwear<br />
                <router-link class="text-white text-smaller" to="/contact-us">
                    Get in touch for a free quote
                </router-link>
            </h1>
        </div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-5 medium-offset-1">
                    <router-link
                        to="/sectors/farmingandagriculture"
                        class="workwear-link farming">
                        <span>Agriculture and farming</span>
                    </router-link>
                    <router-link
                        to="/sectors/automotive"
                        class="workwear-link automotive">
                        <span>Automotive</span>
                    </router-link>
                    <router-link
                        to="/sectors/beauty"
                        class="workwear-link beauty">
                        <span>Beauty, wellness and spa</span>
                    </router-link>
                    <router-link
                        to="/sectors/healthcare"
                        class="workwear-link healthcare">
                        <span>Healthcare &amp; PPE</span>
                    </router-link>
                    <router-link
                        to="/sectors/cateringandhospitality"
                        class="workwear-link catering">
                        <span>Catering and hospitality</span>
                    </router-link>
                </div>
                <div class="cell small-12 medium-5 medium-offset-1">
                    <router-link
                        to="/sectors/construction"
                        class="workwear-link construction">
                        <span>Construction and manufacturing</span>
                    </router-link>
                    <router-link
                        to="/sectors/corporatewear"
                        class="workwear-link corporatewear">
                        <span>Corporate and office wear</span>
                    </router-link>
                    <router-link
                        to="/sectors/schoolanduniversity"
                        class="workwear-link schools">
                        <span>Schools and universities</span>
                    </router-link>
                    <router-link
                        to="/sectors/security"
                        class="workwear-link security">
                        <span>Security</span>
                    </router-link>
                    <router-link
                        to="/sectors/warehouseandtransport"
                        class="workwear-link warehouse">
                        <span>Transportation and warehousing</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x pad-top pad-bottom--large">
                <div class="cell small-12 medium-10 medium-offset-1">
                    <h1 class="pad-top">Embroidered Workwear</h1>
                    <p>
                        Personalised uniform is worn daily by billions of people across the world and helps both identification and promotion of a brand or industry. At customised clothing we have a solid understanding of the importance of embroidered workwear and printed teamwear be it worn by employees of a large corporate or a professional sportsman of a team. Although we appreciate different industries work in contrasting environments and therefore require garments to suit these, we believe all employees or team members should be wearing comfortable, and durable workwear finished to a high standard allowing them to perform their jobs safely and effectively.
                    </p>
                    <p>
                        We have a long-standing working relationship with a number of garment manufacturers allowing us to provide you with a range of products appropriate for your business and industry. Although we know these products like the back of our hands, through years of experience, we are aware that the vast selection can be overwhelming and therefore encourage any queries. For all quotes and queries on embroidered uniform, printed workwear, or to learn about other methods to personalise clothing call us or email us today!
                    </p>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Workwear',
    metaInfo() {
        return {
            title: 'Customised & Personalised Work Clothing UK for Men & Women',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Get the comfortable and embroiderd workwear for your team at Customised Clothing. We offer a range of personalised work uniforms and clothing in the UK.' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/workwear' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Workwear.vue